const state = {
    start: null,
    end: null,
    unit: null,
    hours: null
}
const actions = {
    setStartDate({ commit }, { start, end, unit, hours }) {
        commit('setDate', { start, end, unit, hours })
        return { start, end, unit, hours }
    }
}

const mutations = {
    setDate(state, { start, end, unit, hours }) {
        state.start = start;
        state.end = end;
        state.unit = unit;
        state.hours = hours;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}